import Day from './DayOfWeek';

export default Day;
